import React, { useState } from 'react'
import ReservationSummary from '../../components/ReservationSummary'
import FolioList from './folioList'
import './style.css'
import TransactionsGrid from './transactionsGrid'
import FolioOwnerSummary from '../../components/FolioOwnerSummary'
import { Divider } from 'semantic-ui-react'
const HotelId = 5486
const ReservationId = 100722
const Currency = 2

const FolioPage = () => {
    const [selectedFolio, setSelectedFolio] = useState()
    const [reservation, setReservation] = useState()
    return <div className="folio">
        <div className="left-panel">
            <FolioOwnerSummary OwnerId={selectedFolio&&selectedFolio.Owner.EntityId} OwnerTypeId={selectedFolio&&selectedFolio.Owner.EntityTypeId}/>
            <Divider hidden/>
            <ReservationSummary ReservationID={ReservationId} HotelID={HotelId} Currency={Currency} onReservation={setReservation} />
        </div>
        <div className="main-panel">
            <FolioList ReservationID={ReservationId} HotelID={HotelId} Currency={Currency} onSelect={setSelectedFolio} />
            <TransactionsGrid HotelID={HotelId}  currencyId={Currency} transactions={selectedFolio ? selectedFolio.FolioTransactions : []} folio={selectedFolio} reservation={reservation} />
        </div>
        
    </div>
}

export default FolioPage